import { useState } from 'react';
import Lightbox from './Lightbox';
import { optimizeImage } from '../lib/cms';

export default function GalleryGrid({ title = 'Billedgalleri & Dokumentation', images = [], subtitle }) {
  // Element deleted on all subpages per request
  return null;
}
